<template>
  <div class="course-manage">
    <div class="header">
      <div>
        <el-input
          v-model="keyword"
          placeholder="搜索课程名称或教师"
          style="width: 250px; margin-right: 10px"
          @keyup.enter.native="search"
        >
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
        <el-select v-model="categoryId" placeholder="选择分类" style="width: 150px" @change="search" clearable>
          <el-option
            v-for="category in categoryList"
            :key="category.id"
            :label="category.categoryName"
            :value="category.id"
          />
        </el-select>
      </div>
      <!-- <el-button type="primary" @click="showAddDialog">上传课程</el-button> -->
    </div>

    <el-table :data="courseList" style="width: 100%; margin-top: 20px">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column label="封面" width="120">
        <template slot-scope="scope">
          <el-image :src="scope.row.coverImage" style="width: 80px; height: 60px" fit="cover" />
        </template>
      </el-table-column>
      <el-table-column prop="courseName" label="课程名称" />
      <el-table-column prop="accessCode" label="领取码" width="120" />
      <el-table-column prop="teacher" label="教师" width="120" />
      <!-- <el-table-column prop="categoryName" label="分类" width="120" /> -->
      <!-- <el-table-column prop="duration" label="时长(分钟)" width="120" /> -->
      <el-table-column prop="viewCount" label="观看次数" width="120" />
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" @click="showEditDialog(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="loadCourseList"
      style="margin-top: 20px; text-align: center"
    />

    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="700px" :close-on-click-modal="false">
      <el-form :model="formData" label-width="100px" :rules="rules" ref="courseForm">
        <el-form-item label="课程名称" prop="courseName">
          <el-input v-model="formData.courseName" placeholder="请输入课程名称" />
        </el-form-item>
        
        <el-form-item label="课程领取码" prop="accessCode">
          <el-input v-model="formData.accessCode" placeholder="请输入课程领取码">
            <el-button slot="append" @click="generateAccessCode">生成</el-button>
          </el-input>
          <div style="color: #909399; font-size: 12px; margin-top: 5px">
            学生需要输入此领取码才能访问课程
          </div>
        </el-form-item>
        
        <el-form-item label="课程描述">
          <el-input v-model="formData.courseDesc" type="textarea" :rows="3" placeholder="请输入课程描述" />
        </el-form-item>
        
        <el-form-item label="教师" prop="teacher">
          <el-input v-model="formData.teacher" placeholder="请输入教师姓名" />
        </el-form-item>
        
        <!-- <el-form-item label="分类" prop="categoryId">
          <el-select v-model="formData.categoryId" placeholder="请选择分类" style="width: 100%" @change="onCategoryChange">
            <el-option
              v-for="category in categoryList"
              :key="category.id"
              :label="category.categoryName"
              :value="category.id"
            />
          </el-select>
        </el-form-item> -->
        
        <!-- <el-form-item label="时长(分钟)">
          <el-input-number v-model="formData.duration" :min="1" placeholder="请输入课程时长" />
        </el-form-item> -->
        
        <el-form-item label="课程封面" prop="coverImage">
          <el-upload
            class="cover-uploader"
            :action="uploadCoverUrl"
            :on-success="handleCoverSuccess"
            :before-upload="beforeCoverUpload"
            :show-file-list="false"
            accept="image/*"
          >
            <img v-if="formData.coverImage" :src="formData.coverImage" class="cover-preview">
            <i v-else class="el-icon-plus cover-uploader-icon"></i>
          </el-upload>
          <div style="color: #909399; font-size: 12px; margin-top: 5px">
            建议尺寸：16:9，支持jpg、png格式，不超过5MB
          </div>
        </el-form-item>
        
        <el-form-item label="视频文件" prop="videoUrl">
          <el-upload
            class="video-uploader"
            :action="uploadVideoUrl"
            :on-success="handleVideoSuccess"
            :on-progress="handleVideoProgress"
            :before-upload="beforeVideoUpload"
            :show-file-list="false"
            accept="video/*"
          >
            <el-button size="small" type="primary" :loading="videoUploading">
              <i class="el-icon-upload"></i> {{ videoUploading ? '上传中...' : '选择视频文件' }}
            </el-button>
          </el-upload>
          <div v-if="uploadProgress > 0 && uploadProgress < 100" style="margin-top: 10px">
            <el-progress :percentage="uploadProgress"></el-progress>
          </div>
          <div v-if="formData.videoUrl" style="margin-top: 10px">
            <el-tag type="success">
              <i class="el-icon-video-camera"></i> 视频已上传
            </el-tag>
            <el-button type="text" size="small" @click="formData.videoUrl = ''">重新上传</el-button>
          </div>
          <div style="color: #909399; font-size: 12px; margin-top: 5px">
            支持mp4、avi、mov等格式，建议不超过500MB
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import courseApi from '@/api/course'
import categoryApi from '@/api/category'

export default {
  name: 'CourseManage',
  data() {
    return {
      keyword: '',
      categoryId: null,
      courseList: [],
      categoryList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      submitting: false,
      videoUploading: false,
      uploadProgress: 0,
      uploadCoverUrl: `${process.env.VUE_APP_API_BASE_URL}/api/course/upload/cover`,
      uploadVideoUrl: `${process.env.VUE_APP_API_BASE_URL}/api/course/upload/video`,
      formData: {
        id: null,
        courseName: '',
        courseDesc: '',
        coverImage: '',
        videoUrl: '',
        accessCode: '',
        categoryId: null,
        categoryName: '',
        teacher: '',
        duration: 0
      },
      rules: {
        courseName: [
          { required: true, message: '请输入课程名称', trigger: 'blur' }
        ],
        accessCode: [
          { required: true, message: '请输入课程领取码', trigger: 'blur' }
        ],
        teacher: [
          { required: true, message: '请输入教师姓名', trigger: 'blur' }
        ],
        // categoryId: [
        //   { required: true, message: '请选择分类', trigger: 'change' }
        // ],
        coverImage: [
          { required: true, message: '请上传课程封面', trigger: 'change' }
        ],
        videoUrl: [
          { required: true, message: '请上传视频文件', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.loadCourseList()
    this.loadCategoryList()
  },
  methods: {
    async loadCourseList() {
      try {
        const res = await courseApi.getCourseList(this.currentPage, this.pageSize, this.keyword, this.categoryId)
        this.courseList = res.data.data
        this.total = res.data.total
      } catch (error) {
        this.$message.error('加载课程列表失败')
      }
    },
    async loadCategoryList() {
      try {
        const res = await categoryApi.getCategoryList(1, 1000, '')
        this.categoryList = res.data.data
      } catch (error) {
        this.$message.error('加载分类列表失败')
      }
    },
    search() {
      this.currentPage = 1
      this.loadCourseList()
    },
    showAddDialog() {
      this.dialogTitle = '上传课程'
      this.isEdit = false
      this.uploadProgress = 0
      this.formData = {
        id: null,
        courseName: '',
        courseDesc: '',
        coverImage: '',
        videoUrl: '',
        accessCode: '',
        categoryId: null,
        categoryName: '',
        teacher: '',
        duration: 0
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.courseForm) {
          this.$refs.courseForm.clearValidate()
        }
      })
    },
    showEditDialog(row) {
      this.dialogTitle = '编辑课程'
      this.isEdit = true
      this.uploadProgress = 0
      this.formData = { ...row }
      this.dialogVisible = true
    },
    generateAccessCode() {
      // 生成6位随机字母数字组合
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      let code = ''
      for (let i = 0; i < 6; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.formData.accessCode = code
    },
    onCategoryChange(categoryId) {
      const category = this.categoryList.find(c => c.id === categoryId)
      if (category) {
        this.formData.categoryName = category.categoryName
      }
    },
    beforeCoverUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!')
        return false
      }
      return true
    },
    beforeVideoUpload(file) {
      const isVideo = file.type.startsWith('video/')
      const isLt500M = file.size / 1024 / 1024 < 500

      if (!isVideo) {
        this.$message.error('只能上传视频文件!')
        return false
      }
      if (!isLt500M) {
        this.$message.error('视频大小不能超过 500MB!')
        return false
      }
      this.videoUploading = true
      this.uploadProgress = 0
      return true
    },
    handleVideoProgress(event, file, fileList) {
      this.uploadProgress = Math.floor(event.percent)
    },
    handleCoverSuccess(response) {
      if (response.code === 200) {
        this.formData.coverImage = response.data
        this.$message.success('封面上传成功')
      } else {
        this.$message.error('封面上传失败')
      }
    },
    handleVideoSuccess(response) {
      this.videoUploading = false
      this.uploadProgress = 100
      if (response.code === 200) {
        this.formData.videoUrl = response.data
        this.$message.success('视频上传成功')
        setTimeout(() => {
          this.uploadProgress = 0
        }, 1000)
      } else {
        this.$message.error('视频上传失败')
        this.uploadProgress = 0
      }
    },
    async handleSubmit() {
      this.$refs.courseForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            if (this.isEdit) {
              await courseApi.updateCourse(this.formData)
              this.$message.success('更新成功')
            } else {
              await courseApi.addCourse(this.formData)
              this.$message.success('添加成功')
            }
            this.dialogVisible = false
            this.loadCourseList()
          } catch (error) {
            this.$message.error(this.isEdit ? '更新失败' : '添加失败')
          } finally {
            this.submitting = false
          }
        }
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除这个课程吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await courseApi.deleteCourse(id)
          this.$message.success('删除成功')
          this.loadCourseList()
        } catch (error) {
          this.$message.error('删除失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.course-manage {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cover-uploader {
  display: inline-block;
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
}

.cover-uploader-icon:hover {
  border-color: #409EFF;
}

.cover-preview {
  width: 178px;
  height: 100px;
  display: block;
  border-radius: 6px;
  object-fit: cover;
  cursor: pointer;
}
</style>
